<ng-container *transloco="let convert;">
<div data-test-id="save-changes-modal-container" class="modal micromodal-slide" [attr.id]="modalId" aria-hidden="true">
  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div
      data-test-id="save-changes-modal-dialog"
      class="modal__container modal--save-changes"
      role="dialog"
      aria-modal="true"
      aria-labelledby="asve-changes-modal-title"
      aria-describedby="save-changes-modal-title save-changes-modal-desc"
      data-track-region="Don't Save Changes"
    >
      <header class="modal__header">
        <h1 data-test-id="save-changes-modal-title" class="modal__title text-brand" tabindex="-1">
          {{convert('profileManagement.saveChangesModal.title')}}
        </h1>
      </header>

      <div class="modal__content">
        <div class="modal__body">
          <p data-test-id="save-changes-modal-body">
            {{convert('profileManagement.saveChangesModal.body')}}
          </p>
        </div>
      </div>

      <div class="modal__button-container modal__footer">
        <button
          data-test-id="save-changes-modal-cancel-editing-button"
          data-track-elem="button"
          data-track-name="Don't Save Changes"
          class="btn btn-secondary bid-buttons btn-outline-secondary"
          (click)="closeModal('cancelEditing')"
        >
          {{convert('profileManagement.saveChangesModal.cancelEditing')}}
        </button>
        <button
          data-test-id="save-changes-modal-continue-editing-button"
          data-track-elem="button"
          data-track-name="Go Back"
          class="btn btn-primary"
          (click)="closeModal('continueEditing')"
        >
          {{convert('profileManagement.saveChangesModal.continueEditing')}}
        </button>
      </div>

      <button
        data-test-id="save-changes-modal-close-button"
        data-track-elem="button"
        data-track-name="Close"
        data-track-trigger="close"
        class="modal__close"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="closeModal('continueEditing')"
        data-micromodal-close
      >
        <img
          src="../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
          alt="{{convert('common.altCloseModelIcon')}}"
        />
      </button>
    </div>
  </div>
</div>
</ng-container>
